import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSupportButtonActive: false,
  paddingBottomInPX: 50,
  paddingRightInPX: 20,
};

const supportButtonReducer = createSlice({
  name: 'supportButton',
  initialState,
  reducers: {
    setSupportButtonActive(state, action: { type: string; payload: boolean }) {
      state.isSupportButtonActive = action.payload;
    },
    setPaddingBottomInPX(state, action: { type: string; payload: number }) {
      state.paddingBottomInPX = action.payload;
    },
    setPaddingRightInPX(state, action: { type: string; payload: number }) {
      state.paddingRightInPX = action.payload;
    },
  },
});

export const { setSupportButtonActive, setPaddingRightInPX, setPaddingBottomInPX } = supportButtonReducer.actions;

export default supportButtonReducer.reducer;
